import * as Scrivito from "scrivito";
import I18n from "^/config/i18n";

const validityCheck = (Component) =>
  Scrivito.connect(({ ...props }) => {
    const validFrom = Scrivito.currentPage().get("validFrom");
    const validUntil = Scrivito.currentPage().get("validUntil");
    const editing = Scrivito.isInPlaceEditingActive();
    const now = new Date();
    const isValid = now >= validFrom && (!validUntil || now <= validUntil);
    const validityInfo =
      editing && !isValid
        ? `
            Nicht im Gültigkeitszeitraum von
            ${validFrom ? validFrom.toLocaleDateString("en") : "…"}
            bis
            ${validUntil ? validUntil.toLocaleDateString("en") : "…"}
        `
        : "";
    if (isValid || editing) {
      return (
        <div>
          <div className="text-center strong text-danger">{validityInfo}</div>
          <Component {...props} />
        </div>
      );
    }
    return (
      <div className="not-valid-container">
        <div className="text-center">
          <h1 className="not-valid-header">
            {I18n.t("Message shown for outdated pages")}
          </h1>
        </div>
      </div>
    );
  });

export default validityCheck;
